import { getCookies, setCookie } from 'lib/web/cookieUtils'

export const HERO_HEADLINE_USP_COOKIE = 'hero-headlline-usp-seen'
const COOKIE_ONE_YEAR_TTL = 3.156e7
const COOKIE_PATH = '/'
const COOKIE_SAME_SITE = 'Lax'
const FIRST_TIME_WINDOW_IN_SECONDS = 2.592e8 // 3 days

function getHeadlineFirstTimeCookie() {
  const cookies = getCookies()
  return Number(cookies[HERO_HEADLINE_USP_COOKIE])
}

export function setFirstTimeUser() {
  const timestamp = getHeadlineFirstTimeCookie()
  if (timestamp && !isNaN(timestamp)) return
  setCookie(HERO_HEADLINE_USP_COOKIE, new Date().getTime().toString(), COOKIE_ONE_YEAR_TTL, COOKIE_PATH, COOKIE_SAME_SITE)
}

export function heroHeadlineFirstTimeUser(timestamp?: number) {
  if (!timestamp || isNaN(timestamp)) return true
  const diff = new Date().getTime() - timestamp
  return diff < FIRST_TIME_WINDOW_IN_SECONDS
}
